import React from 'react';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';

const CardWithTitleAndButton = ({
  title,
  children,
  className,
  capitalize = false,
  buttons = [],
  showButtons = true,
}) => {
  return (
    <Card
      className={`border-0 shadow-none position-relative ${className} ${capitalize}`}
    >
      <CardBody className="pb-2">
        <Row>
          <Col>
            {title && <h4 className="f-16 mb-3 fw-semibold">{title}</h4>}
          </Col>
          {showButtons && (
            <Col className="justify-content-end d-flex gap-3">
              {buttons.map((button) => button)}
            </Col>
          )}
        </Row>

        {children}
      </CardBody>
    </Card>
  );
};

export default CardWithTitleAndButton;
